export default {
  '成绩列表':'成绩列表',
  '锻炼时间':'锻炼时间',
  '导出数据':'导出数据',
  '或':'或',
  '设为无效':'设为无效',
  '恢复有效':'恢复有效',
  '视频回放':'视频回放',
  '比赛记录':'比赛记录',
  '最佳成绩':'最佳成绩',
  '完成时间':'完成时间',
  '个人榜':'个人榜',
  '比赛明细':'比赛明细',
  '管理人员可通过视频情况将成绩处理为“无效”，无效的成绩不会参与任何排行，请慎重操作！':'管理人员可通过视频情况将成绩处理为“无效”，无效的成绩不会参与任何排行，请慎重操作！',
  '请输入用户姓名，学校名模糊搜索':'请输入用户姓名，学校名模糊搜索',
}